// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
/** Fixed scope attribute value for every TipTap HTML document editor instance. */
export const EDITOR_SCOPE_ID = 'editor';

/**
 * Scope CSS selectors under `[data-editor-scope="…"]` so template `body {}` rules
 * apply inside the editor root (TipTap has no `<body>` in the DOM).
 */
export const scopeCSS = (css: string, scopeId: string): string => {
  const scopePrefix = `[data-editor-scope="${scopeId}"]`;

  try {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css);

    const processRules = (rules: CSSRuleList): string => {
      let result = '';

      for (let i = 0; i < rules.length; i++) {
        const rule = rules[i];

        if (rule instanceof CSSStyleRule) {
          const originalSelector = rule.selectorText;

          const scopedSelector = originalSelector
            .split(',')
            .map((s) => {
              const trimmed = s.trim();
              if (trimmed.startsWith(scopePrefix)) {
                return trimmed;
              }
              return `${scopePrefix} ${trimmed}`;
            })
            .join(', ');

          result += `${scopedSelector} { ${rule.style.cssText} } `;
        } else if (rule instanceof CSSMediaRule) {
          result += `@media ${rule.conditionText} { `;
          result += processRules(rule.cssRules);
          result += '} ';
        } else if (rule instanceof CSSSupportsRule) {
          result += `@supports ${rule.conditionText} { `;
          result += processRules(rule.cssRules);
          result += '} ';
        } else {
          result += rule.cssText + ' ';
        }
      }

      return result.trim();
    };

    return processRules(sheet.cssRules);
  } catch {
    return css;
  }
};

/** Strip any `[data-editor-scope="…"]` prefix before persisting CSS in HTML. */
export const unscopeCSS = (css: string): string => {
  const scopePattern = /\[data-editor-scope="[^"]+"\]\s*/g;
  return css.replace(scopePattern, '');
};

/** Matches every `<style>...</style>` block in an HTML string (head or body). */
export const STYLE_TAG_REGEX = /<style\b[^>]*>([\s\S]*?)<\/style>/gi;

export const normalizeCSSBlock = (css: string): string => css.replace(/\s+/g, ' ').trim();

/** Normalized CSS bodies from every `<style>` in an HTML fragment. */
export const extractStyleCSSBlocks = (html: string): Set<string> => {
  const set = new Set<string>();
  for (const m of html.matchAll(STYLE_TAG_REGEX)) {
    const normalized = normalizeCSSBlock(m[1]);
    if (normalized) set.add(normalized);
  }
  return set;
};
